/* ALTIER: free gifts with glasses, VIP add-on (Seal), mix-and-match bundles, offer timer, video sound, colour label */
(function () {
  var CFG = window.AltierConfig || {};
  var FRAMES = CFG.frames || [];
  var GIFTS = CFG.gifts || [];
  var VIP = CFG.vip || 0;
  var VIP_PLAN = CFG.vipPlan || 0;
  var origFetch = window.fetch.bind(window);

  function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || ''; }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u); }
  function isChange(u) { return /\/cart\/(change|update)(\.js)?(\?|$)/.test(u); }
  function getCart() { return origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function vipChecked() { var el = document.querySelector('[data-altier-vip]'); return !!(el && el.checked); }
  function isFrame(id) { return FRAMES.indexOf(Number(id)) !== -1; }
  function post(url, body) { return origFetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function bundleSize() {
    var sel = document.querySelector('[data-altier-bundles] input[name="altier-bundle"]:checked');
    return sel ? Number(sel.value) : 1;
  }
  function bundlePicks() {
    var box = document.querySelector('[data-altier-bundles]');
    if (!box) return [];
    var n = bundleSize(), out = [];
    for (var i = 2; i <= n; i++) {
      var r = box.querySelector('input[name="altier-pair-' + i + '"]:checked');
      if (r) out.push({ id: Number(r.value), quantity: 1 });
    }
    return out;
  }

  function extrasFor(cart) {
    var inCart = cart.items.map(function (i) { return i.variant_id; });
    var out = bundlePicks();
    GIFTS.forEach(function (g) { if (g && inCart.indexOf(g) === -1) out.push({ id: g, quantity: 1 }); });
    if (VIP && vipChecked() && inCart.indexOf(VIP) === -1) {
      var v = { id: VIP, quantity: 1 };
      if (VIP_PLAN) v.selling_plan = VIP_PLAN;
      out.push(v);
    }
    return out;
  }

  function rebuildFormData(fd, extra) {
    var out = new FormData();
    var hasItems = false;
    fd.forEach(function (v, k) { if (/^items\[/.test(k)) hasItems = true; });
    var idx = 0;
    if (!hasItems && fd.get('id')) {
      out.append('items[0][id]', fd.get('id'));
      out.append('items[0][quantity]', fd.get('quantity') || '1');
      if (fd.get('selling_plan')) out.append('items[0][selling_plan]', fd.get('selling_plan'));
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m) out.append('items[0][properties][' + m[1] + ']', v);
      });
      idx = 1;
    }
    fd.forEach(function (v, k) {
      if (!hasItems && (k === 'id' || k === 'quantity' || k === 'selling_plan' || /^properties\[/.test(k))) return;
      out.append(k, v);
      var m = k.match(/^items\[(\d+)\]/);
      if (m) idx = Math.max(idx, Number(m[1]) + 1);
    });
    extra.forEach(function (e) {
      out.append('items[' + idx + '][id]', e.id);
      out.append('items[' + idx + '][quantity]', e.quantity);
      if (e.selling_plan) out.append('items[' + idx + '][selling_plan]', e.selling_plan);
      idx++;
    });
    return out;
  }

  function addingIds(body) {
    var ids = [];
    try {
      if (body instanceof FormData) {
        if (body.get('id')) ids.push(body.get('id'));
        body.forEach(function (v, k) { if (/^items\[\d+\]\[id\]$/.test(k)) ids.push(v); });
      } else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body);
        (j.items || (j.id ? [j] : [])).forEach(function (it) { ids.push(it.id); });
      }
    } catch (e) {}
    return ids;
  }

  /* Keep gifts in sync with glasses: no glasses = no gifts; glasses = exactly one of each gift */
  var syncing = false;
  function syncGifts() {
    if (syncing || !GIFTS.length) return;
    getCart().then(function (cart) {
      var hasFrame = cart.items.some(function (i) { return isFrame(i.variant_id); });
      var qty = {};
      cart.items.forEach(function (i) { qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
      var updates = {}, any = false;
      GIFTS.forEach(function (g) {
        var want = hasFrame ? 1 : 0;
        if ((qty[g] || 0) !== want) { updates[g] = want; any = true; }
      });
      if (!hasFrame && VIP && qty[VIP]) { updates[VIP] = 0; any = true; }
      if (!any) return;
      syncing = true;
      var missing = GIFTS.filter(function (g) { return hasFrame && !qty[g]; });
      var p = missing.length
        ? post('/cart/add.js', { items: missing.map(function (g) { return { id: g, quantity: 1 }; }) }).then(function () {
            var rest = {}; Object.keys(updates).forEach(function (k) { if (missing.indexOf(Number(k)) === -1) rest[k] = updates[k]; });
            return Object.keys(rest).length ? post('/cart/update.js', { updates: rest }) : null;
          })
        : post('/cart/update.js', { updates: updates });
      p.then(function () { return refreshCartSections(); }).then(function () { syncing = false; }, function () { syncing = false; });
    }).catch(function () {});
  }

  window.fetch = function (input, init) {
    var u = urlOf(input);
    var body = init && init.body;
    if (isAdd(u) && body && GIFTS.length) {
      var ids = addingIds(body);
      if (ids.some(isFrame)) {
        return getCart().then(function (cart) {
          var extra = extrasFor(cart);
          if (!extra.length) return origFetch(input, init);
          var next = Object.assign({}, init);
          if (body instanceof FormData) {
            next.body = rebuildFormData(body, extra);
          } else {
            var j = JSON.parse(body);
            if (!j.items) { j.items = [{ id: j.id, quantity: j.quantity || 1, properties: j.properties, selling_plan: j.selling_plan }]; delete j.id; delete j.quantity; delete j.properties; delete j.selling_plan; }
            j.items = j.items.concat(extra);
            next.body = JSON.stringify(j);
          }
          return origFetch(input, next);
        }).catch(function () { return origFetch(input, init); });
      }
    }
    var p = origFetch(input, init);
    if (isChange(u)) p.then(function () { setTimeout(syncGifts, 300); }).catch(function () {});
    return p;
  };

  /* Expose the theme's section renderer. Injected at runtime (after the import map exists)
     because Shopify's asset minifier rewrites dynamic import() in this file. */
  function exposeRenderer() {
    if (window.AltierSectionRenderer || document.getElementById('altier-renderer')) return;
    var s = document.createElement('script');
    s.type = 'module';
    s.id = 'altier-renderer';
    s.textContent = "import { sectionRenderer } from '@theme/section-renderer'; window.AltierSectionRenderer = sectionRenderer;";
    document.head.appendChild(s);
  }
  function getRenderer() {
    exposeRenderer();
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        if (window.AltierSectionRenderer) return resolve(window.AltierSectionRenderer);
        if (++tries > 60) return resolve(null);
        setTimeout(check, 50);
      })();
    });
  }
  function renderCartOnce(renderer, ids) {
    return Promise.all(ids.map(function (id) {
      var url = new URL(window.location.href);
      url.searchParams.set('altier_ts', String(Date.now()));
      return renderer.renderSection(id, { cache: false, mode: 'full', url: url });
    }));
  }
  function refreshCartSections() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    if (!ids.length) return Promise.resolve();
    return getRenderer().then(function (renderer) {
      if (!renderer) { window.location.reload(); return; }
      return wait(150).then(function () { return renderCartOnce(renderer, ids); })
        .then(function () { return wait(900); })
        .then(function () { return renderCartOnce(renderer, ids); });
    }).catch(function () {});
  }

  function applyCode(code) {
    return post('/cart/update.js', { discount: code })
      .then(function (r) { return r.json(); })
      .then(function (data) { return refreshCartSections().then(function () { return data; }); });
  }

  /* 10-minute welcome offer: starts on first visit, never resets for this browser.
     Re-queries every second so timers inside the re-rendered cart drawer keep ticking. */
  function initTimer() {
    var KEY = 'altier_offer5_start';
    var CLAIMED = 'altier_offer5_claimed';
    var LIMIT = 10 * 60 * 1000;
    var start;
    try { start = Number(localStorage.getItem(KEY)); if (!start) { start = Date.now(); localStorage.setItem(KEY, String(start)); } } catch (e) { start = Date.now(); }
    var claimed = false;
    try { claimed = localStorage.getItem(CLAIMED) === '1'; } catch (e) {}
    function tick() {
      var left = start + LIMIT - Date.now();
      var m = Math.max(0, Math.floor(left / 60000)), s = Math.max(0, Math.floor((left % 60000) / 1000));
      var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      document.querySelectorAll('[data-altier-timer]').forEach(function (bar) {
        if (left <= 0) { bar.hidden = true; return; }
        bar.hidden = false;
        bar.querySelectorAll('[data-altier-clock]').forEach(function (out) { out.textContent = txt; });
        bar.classList.toggle('is-claimed', claimed);
      });
      if (left > 0) setTimeout(tick, 1000);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-altier-claim]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var code = btn.getAttribute('data-code');
      btn.disabled = true;
      btn.textContent = '...';
      claimed = true;
      try { localStorage.setItem(CLAIMED, '1'); } catch (e2) {}
      document.querySelectorAll('[data-altier-timer]').forEach(function (b) { b.classList.add('is-claimed'); });
      applyCode(code).catch(function () {
        claimed = false;
        try { localStorage.removeItem(CLAIMED); } catch (e3) {}
        document.querySelectorAll('[data-altier-timer]').forEach(function (b) { b.classList.remove('is-claimed'); });
        btn.disabled = false; btn.textContent = 'Claim';
      });
    }, true);
    tick();
  }

  /* Bundle picker: shows a style chooser for each extra pair */
  function initBundles() {
    var box = document.querySelector('[data-altier-bundles]');
    if (!box) return;
    var picks = box.querySelector('[data-altier-picks]');
    function refresh() {
      var n = bundleSize();
      if (picks) picks.hidden = n < 2;
      box.querySelectorAll('[data-altier-pick-row]').forEach(function (row) { row.hidden = Number(row.getAttribute('data-altier-pick-row')) > n; });
    }
    box.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'altier-bundle') refresh();
      var m = t.name && t.name.match(/^altier-pair-(\d)$/);
      if (m) { var lab = box.querySelector('[data-altier-pick-name="' + m[1] + '"]'); if (lab) lab.textContent = t.getAttribute('data-name'); }
    });
    refresh();
  }

  /* Reels: play when visible, tap for sound */
  function initReels() {
    var vids = document.querySelectorAll('.arl__video');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
    document.querySelectorAll('[data-altier-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.arl__card');
        var v = card && card.querySelector('video');
        if (!v) return;
        var turnOn = v.muted;
        document.querySelectorAll('.arl__video').forEach(function (o) { o.muted = true; var c = o.closest('.arl__card'); if (c) c.classList.remove('is-sound'); });
        if (turnOn) { v.muted = false; v.currentTime = 0; v.play(); card.classList.add('is-sound'); }
      });
    });
  }

  function initColourLabel() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !/^colou?r$/i.test(t.getAttribute('data-option-name') || '')) return;
      document.querySelectorAll('.variant-option__swatch-value, [data-altier-pair1]').forEach(function (el) { el.textContent = t.value; });
    });
  }

  function init() { exposeRenderer(); initTimer(); initBundles(); initReels(); initColourLabel(); if (/\/cart/.test(location.pathname)) syncGifts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
